module.exports = __webpack_public_path__ + "img/2ne.1003b484.svg";